import { GetDjuYearSiteSchemaResponse } from '@shared/schema/site.get-dju-year.schema'
import { queryOptions } from '@tanstack/react-query'

import { type QueryOptionsData } from '@/@types/query'
import { apiFetch } from '@/lib/api-fetch'

export function siteDjuYearQuery() {
  return queryOptions({
    queryKey: ['site', 'dju-year'],
    async queryFn() {
      const rawResponse = await apiFetch.get('site/dju-year')

      if (!rawResponse.ok) {
        throw new Error(`Failed to fetch site dju year`)
      }

      try {
        return await GetDjuYearSiteSchemaResponse.parseAsync(await rawResponse.json())
      } catch (error) {
        throw new Error('Failed to parse dju year response', { cause: error })
      }
    },
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  })
}

export type SiteDjuYear = QueryOptionsData<typeof siteDjuYearQuery>
